module.exports = "- Front-end landscape shifts away from PHP\n\n- September 2011\n  - Facebook moved a lot of their applications to JS\n  - MVC framework called BoltJS\n  - Apps grow -> Complicated codebases\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/notes_5.md
// module id = 1486
// module chunks = 0